import { render, staticRenderFns } from "./productBrochureStyle.vue?vue&type=template&id=76a2ce92&scoped=true"
import script from "./productBrochureStyle.vue?vue&type=script&lang=js"
export * from "./productBrochureStyle.vue?vue&type=script&lang=js"
import style0 from "./productBrochureStyle.vue?vue&type=style&index=0&id=76a2ce92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a2ce92",
  null
  
)

export default component.exports